import { Alert, Button, Stack, Typography } from '@mui/material'
import { useState } from 'preact/hooks'
import { api } from '../api/client'
import type { Answer } from '../api/generated/Answer'
import type { NewAnswers } from '../api/generated/NewAnswers'
import type { Question } from '../api/generated/Question'
import { useAction } from '../api/useAction'
import { useApi } from '../api/useApi'
import { useSession } from '../auth/session'
import { AnswerFields } from './AnswerFields'
import { type AnswerForm, answersOf, formOf } from './form'

/** A member's answers to the event's questions, to edit; hidden when there are none. */
export function MyAnswers({ slug }: { slug: string }) {
  const { me } = useSession()
  const path = `/events/${slug}/answers`
  const questions = useApi<Question[]>(`/events/${slug}/questions`)
  const answers = useApi<Answer[]>(path)
  const [edited, setEdited] = useState<AnswerForm>()
  const [saved, setSaved] = useState(false)
  const { error, pending, run } = useAction()
  const loadError = questions.error ?? answers.error
  if (loadError) return <Alert severity="error">{loadError}</Alert>
  if (!me || !questions.data?.length || !answers.data) return null

  const list = questions.data
  const form = edited ?? formOf(answers.data, me.id)
  const submit = (e: Event) => {
    e.preventDefault()
    run(async () => {
      const body: NewAnswers = { answers: answersOf(form, list) }
      answers.setData(await api.post<Answer[]>(path, body))
      setEdited(undefined)
      setSaved(true)
    })
  }
  return (
    <Stack component="form" spacing={2} onSubmit={submit}>
      <Typography variant="h6">Mes réponses</Typography>
      <AnswerFields
        questions={list}
        value={form}
        onChange={(next) => {
          setEdited(next)
          setSaved(false)
        }}
      />
      {error && <Alert severity="error">{error}</Alert>}
      {saved && <Alert severity="success">Réponses enregistrées.</Alert>}
      <Button
        type="submit"
        variant="outlined"
        disabled={!edited}
        loading={pending}
        sx={{ alignSelf: 'flex-start' }}
      >
        Enregistrer mes réponses
      </Button>
    </Stack>
  )
}
